if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.upsellVariantId = this.dataset.upsellVariantId;


        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const bundleItems = this.getBundleVariantItems();
        const primaryVariantId = bundleItems ? String(bundleItems[0].id) : formData.get('id');
        if (bundleItems) {
          // The Shopify Ajax Cart API supports multiple variant IDs in one request.
          // Remove the standard single-variant fields to avoid adding an extra item.
          formData.delete('id');
          formData.delete('quantity');
          bundleItems.forEach((item, index) => {
            formData.append(`items[${index}][id]`, item.id);
            formData.append(`items[${index}][quantity]`, item.quantity);
          });
        }
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

          this.skipCart = false;
      if (this.form.querySelector('[name=id]').dataset.skipCart && this.form.querySelector('[name=id]').dataset.skipCart === 'true') {
        this.skipCart = true;
      }
        
        (async () => {
          const upsellElement = this.closest('section, [id^="MainProduct-"]')
            ?.querySelector('[data-faneclat-upsell-source="product"]');
          let upsellDesired = upsellElement
            ? upsellElement.checked
            : this.dataset.upsellDefaultSelected === 'true';
          const linkedVariantId = String(this.upsellVariantId || '');
          let inCartAlready = true; // Fail closed against duplicate upsells if cart lookup fails.
          if (upsellDesired && linkedVariantId) {
            try {
              const cartResponse = await fetch(`${routes.cart_url}.js`, { cache: 'no-store' });
              if (cartResponse.ok) {
                const cartState = await cartResponse.json();
                inCartAlready = cartState.items.some(item => String(item.variant_id) === linkedVariantId);
                // Preserve the former cart-default behaviour only for an empty cart.
                // The visible product checkbox is always the authoritative choice.
                if (!upsellElement && cartState.item_count > 0) upsellDesired = false;
              }
            } catch (error) { console.warn('FanGlow™: unable to read cart', error); }
          }
          const mainResponse = await fetch(`${routes.cart_add_url}`, config);
          const mainData = await mainResponse.json();
          if (!mainResponse.ok || mainData.status) return mainData;
          const sameAsPrimary = String(primaryVariantId) === linkedVariantId ||
            (bundleItems && bundleItems.some(item => String(item.id) === linkedVariantId));
          if (!upsellDesired || !linkedVariantId || inCartAlready || sameAsPrimary) return mainData;
          try {
            const upsellConfig = this.getUpsellProductConfig();
            const upsellResponse = await fetch(`${routes.cart_add_url}`, upsellConfig);
            const upsellData = await upsellResponse.json();
            if (!upsellResponse.ok || upsellData.status) throw new Error(upsellData.description || upsellData.message || 'Option unavailable.');
            return upsellData;
          } catch (error) {
            if (window.FaneclatSyncedUpsell) window.FaneclatSyncedUpsell.showError(error.message);
            return mainData; // Main product was added; do not misreport it as a failure.
          }
        })()
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: primaryVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (this.skipCart) {
              window.location = "/checkout";
             return;
           } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: primaryVariantId,
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
            if (window.FaneclatSyncedUpsell) window.FaneclatSyncedUpsell.refresh();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }
            getBundleVariantItems() {
        // Only change submission when the merchant explicitly enables the feature.
        const container = Array.from(document.querySelectorAll(
          '.quantity-breaks-container[data-variants-enabled="true"]'
        )).find((element) => element.dataset.productFormId === this.form.id);
        if (!container) return null;

        const selectedRadio = container.querySelector('input[type="radio"][name="quantity"]:checked');
        if (!selectedRadio) return null;
        const selectedOffer = container.querySelector(`label[for="${selectedRadio.id}"]`);
        if (!selectedOffer) return null;

        const selectors = Array.from(selectedOffer.querySelectorAll('.quantity-break__variant-select'));
        if (selectors.length !== Number(selectedRadio.value) || !selectors.length) return null;

        // Merge matching variants, keeping the quantities the buyer selected.
        const quantities = new Map();
        selectors.forEach((selector) => {
          const variantId = selector.value;
          if (!variantId) return;
          quantities.set(variantId, (quantities.get(variantId) || 0) + 1);
        });
        return Array.from(quantities, ([id, quantity]) => ({ id, quantity }));
      }

      getUpsellProductConfig() {
        const upsellFormData = new FormData();
        upsellFormData.append('id', this.upsellVariantId);
        upsellFormData.append('quantity', 1);
        upsellFormData.append('properties[_faneclat_upsell]', '1');
        if (this.cart) {
          upsellFormData.append('sections', this.cart.getSectionsToRender().map(section => section.id));
          upsellFormData.append('sections_url', window.location.pathname);
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = upsellFormData;

        return config;
      }


      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
